import * as PropTypes from 'prop-types';

export const PTContentSection = PropTypes.shape({
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
}).isRequired;

export const PTAPIService = PropTypes.shape({
  post: PropTypes.func.isRequired,
});

export const PTCookieSerice = PropTypes.shape({
  get: PropTypes.func.isRequired,
  set: PropTypes.func.isRequired,
  getAll: PropTypes.func.isRequired,
});

export const PTContent = PropTypes.shape({
  title: PropTypes.string.isRequired,
  info: PropTypes.string.isRequired,
  button: PropTypes.string.isRequired,
  secondaryButton: PropTypes.shape({
    default: PropTypes.string.isRequired,
    selection: PropTypes.string.isRequired,
  }).isRequired,
  selectionInfo: PropTypes.string.isRequired,
  essential: PTContentSection,
  analytical: PTContentSection,
  marketing: PTContentSection,
});
